export default function cleanEmptyField(obj) {
  return Object.keys(obj).reduce((prev, field) => {
    const value = obj[field];
    if (value && value.length === 0) {
      return prev;
    }
    return ['', null, undefined, false].includes(value) ? prev : {...prev, [field]: value};
  }, {});
}
